var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "JadePopover",
    _vm._b(
      {
        attrs: {
          open: _vm.open,
          "z-index": 900,
          "allowed-placements": _vm.allowedPlacements,
          offset: _vm.offset,
        },
        on: { toggleOpen: _vm.toggleOpen, closePopover: _vm.closePopover },
        scopedSlots: _vm._u(
          [
            {
              key: "trigger",
              fn: function () {
                return [_vm._t("trigger")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "JadePopover",
      _vm.$props,
      false
    ),
    [
      _c("div", { staticClass: "jade-dropdown" }, [
        _c(
          "div",
          { staticClass: "jade-dropdown__content" },
          [[_vm._t("default")]],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }